module.exports = __webpack_public_path__ + "img/gwyx-yzyxyjhcf.07786fb8.png";